export default function (h: any) {
  const shapFeedbackButton = (vote: number) => {
    return {
      class: { 'sp__button': true },
      on: {
        click: this.sendDocFeedback.bind(this, vote),
        mouseenter: () => { this.deviation = `${vote ? '-' : ''}` }
      }
    }
  }

  const content = [
    h('header.sp__header', { on: { click: this.toggleFeedbackPanel } }, [
      h('i.iconfont.icon-talk'),
      h('span', this.leadin)
    ]),
    h('div.sp__body', [
      h('button', shapFeedbackButton(5), [
        h('i.iconfont.icon-smile')
      ]),
      h('button', shapFeedbackButton(0), [
        h('i.iconfont.icon-sad')
      ]),
      h('div.sp__feedback', {
        style: {
          transform: `translateX(${this.deviation}30%)`
        }
      }, this.feedback)
    ])
  ]

  return h('section.sp__container--suspension', {
    class: {
      'sp__container--feedback': this.voted,
      'sp__container--full': this.spreading
    }
  }, content)
}
